import { useConnectStore } from '../../../../store/models';

/*
 * Reads the CDN-hosted "more details" copy (subtitle/summary/features) for
 * integrations from the connect store. getIntegrationDetails is kicked off
 * once on PlansBrowseView mount, alongside browseConnectIntegrations.
 */
function useIntegrationDetails () {
    const connectStore = useConnectStore();

    // integrationDetailsLoading is a real boolean; integrationDetails is a uuid
    // change-token (set once getIntegrationDetails resolves) coerced to a
    // "resolved" boolean.
    const loading = connectStore.observed.integrationDetailsLoading;
    const resolved = !!connectStore.observed.integrationDetails;

    return {
        integrationDetails: connectStore.integrationDetails,
        loading: loading || !resolved,
    };
}

export default useIntegrationDetails;
